import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import counterReducer from '../features/counter/counterSlice'
import articleReducer from '../features/article/data/articleSlice'
import themeReducer from '../features/theme/data/themeSlice'
import applicationSlice from '../features/application/applicationSlice'
import queueSlice from '../features/queue/queueSlice'
import searchSlice from '../features/search/searchSlice'
import { isArticleWidget } from '../shared/utils/url'

const parentHost = window.location.ancestorOrigins?.[0] || document.referrer
const publisherEndpoint = parentHost && parentHost.length ? new URL(parentHost).hostname : window.location.hostname

const publisherKey = new URLSearchParams(window.location.search).get('key')!

// parsing articleIds
const articleIds = (() => {
    const articleIds = new URLSearchParams(window.location.search).get('articleIds')
    if (!articleIds) return null

    try {
        const parsed = JSON.parse(articleIds)
        if (Array.isArray(parsed) && parsed.length) {
            return parsed as number[]
        }
        return null
    } catch {
        return null
    }
})()

let storageKey

if (!isArticleWidget()) {
    // storage could be different based on the website,publisherKey and playlistType
    if (articleIds) {
        const idsCombined = articleIds.reduce((combined, currentId) => `${combined}:${currentId}`, '').substring(1)
        storageKey = `${publisherEndpoint}:${publisherKey}:${idsCombined}`
    } else {
        storageKey = `${publisherEndpoint}:${publisherKey}`
    }
} else {
    const articleId = new URLSearchParams(window.location.search).get('id')!
    storageKey = `${publisherEndpoint}:${publisherKey}:${articleId.replace(' ', '')}`
}

const persistConfig = {
    key: storageKey,
    storage,
    whitelist: ['article', 'queue'],
}

const rootReducer = combineReducers({
    counter: counterReducer,
    article: articleReducer,
    theme: themeReducer,
    application: applicationSlice,
    queue: queueSlice,
    search: searchSlice,
})

export const store = configureStore({
    reducer: persistReducer(persistConfig, rootReducer),
})

export const persistor = persistStore(store)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
